import type { ComponentEditorMetaDataDefinition } from '../types';

import constants from '#packages/constants';

import { documentTypeUtils } from '@wix/santa-editor-utils';

const metaData: ComponentEditorMetaDataDefinition = {
  nestedBackgroundDesign: true,
  slidesContainer: true,
  focusable: true,
  canContain: false,
  canContainByStructure: false,
  overridesWhenReferred: {
    gfpp: {
      disableMainActionsByLabelKey: [
        constants.BOX_SLIDE_SHOW.GFPP.ACTIONS.LABELS
          .REGULAR_SLIDESHOW_SETTINGS_MANAGE_SLIDES,
      ],
    },
  },
  supportedInCurrentDocument: () =>
    !documentTypeUtils.isCurrentDocumentTypeIsFluidDocument(),
};

export default metaData;
